import React from 'react';
import "../../../../SCSS/setup.scss";
import '../../../../SCSS/input.scss';
// import Loader from '../../../../../utils/loader/loaders';
import Axios from 'axios';
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from 'react-router-dom';
import KenPaginationUI from "../../../../global_components/KenPaginator";
import employeeForm from './add-employee.json';
import ZenTabs from '../../../../global_components/KenForm/tabs';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined'
import LinearProgress from '@material-ui/core/LinearProgress'
import RestoreOutlinedIcon from '@material-ui/icons/RestoreOutlined';
import KeyboardBackspaceSharpIcon from '@material-ui/icons/KeyboardBackspaceSharp';
import { Alert } from 'rsuite';
import moment from 'moment';
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import ZqHistory from '../../../../../gigaLayout/change-history';
// import zq_api from '../../../../../utils/api-service';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import existForm from './exist-form.json';
import editForm from './edit-form.json';
import KenForm from "../../../../global_components/KenForm/zqform";
import xlsx from "xlsx";
import {
    Button,
    ButtonGroup,
    ButtonToolbar,
    CheckTree,
    Modal,
    Drawer,
    Timeline,
    TreePicker,
    Icon,
} from "rsuite";
import { SelectPicker } from "rsuite";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import reactOtpInput from 'react-otp-input';
import WorkExperience from './workExp/workExperience';

class Employees extends React.Component {
    constructor(props) {
        super(props);
        // this.zq_api = new zq_api();
        this.state = {
            printTime: '',
            workExpData: [],
            employeeDetails: [],
            useremail: localStorage.getItem('email'),
            phone: localStorage.getItem('phone'),
            channel: localStorage.getItem('channel'),
            env: JSON.parse(localStorage.getItem('env')),
            authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
            BranchId: '',
            orgId: "606ac70479dbb25447375fa8",
            orgName: localStorage.getItem('orgName'),
            username: localStorage.getItem('username'),
            noProg: 'Fetching Details..',
            monthName: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            loader: false,
            page: 1,
            limit: 10,
            totalRecord: 0,
            totalPages: 1,
            tabview: true,
            employeeFormData: [],
            employeeName: '',
            Employee: "",
            history: false,
            showHistory: false,
            historyData: [],
            globalSearch: false,
            entityInstanceId: undefined,
            preview: false,
            idosId: '',
            containerNav: {
                isBack: false,
                name: 'List of Employees',
                isName: true,
                total: 0,
                isTotalCount: false,
                isSearch: false,
                isSort: false,
                isPrint: true,
                isDownload: false,
                isShare: false,
                isDownloadProcessing: true,
                dwnldPrcsBtn: 'Download',
                isUpload: true,
                uploadName: 'Upload',
                isNew: true,
                newName: "New",
                isSubmit: false,

            },
            finalCount: undefined,
            modelboxDetails: {
                openNotificationModel: false,
                modelHeading: "",
                modelStatus: "",
                modelBodyContent: "",
                modelFooterSubBtn: true,
                modelFooterCancelBtn: true,
            },
            snackBar: false,
            processMessage: "",
            existForm: existForm,
            editForm: editForm,
            employeeStatus: '',
            activeTab: 0,
            employeeId: '',
            tabData: [],
            tableResponse: 'Fetching Details..',
            showUploadform: true,
            BankStatementData: [],
            //upload process
            extractData: false,
            filename: '',
            upload: false,
            files: [],
            error: '',
            formData: '',
            fileSize: '',
            pdfLoaded: 0,
            processLoaded: 0,
            pdfName: undefined,
            showViewer: false,
            pdfExtract: false,
            employeeLists: [],
            addDepartId: ""
        }
        this.inputFile = React.createRef(this.inputFile);
        this.tabRef = React.createRef(this.tabRef);

    }


    componentDidMount() {
        console.log("props", this.props)
        if (this.props.location.state != undefined) {
            if (this.props.location.state.data != undefined) {
                let item = JSON.parse(this.props.location.state.data)
                let withSalutation = (item.personReferenceId[0].salutation != null ? (item.personReferenceId[0].salutation + ".") : "") + item.personReferenceId[0].firstName + " " + (item.personReferenceId[0].lastName != null ? String(item.personReferenceId[0].lastName).replace("-", "") : "")
                let withoutSalutation = item.personReferenceId[0].firstName + " " + (item.personReferenceId[0].lastName != null ? String(item.personReferenceId[0].lastName).replace("-", "") : "")
                let createdBy = "-"
                if (item.createdPersonInfo.length > 0) {
                    createdBy = (String(item.createdPersonInfo[0].salutation).length > 1 ? (item.createdPersonInfo[0].salutation + ".") : "") + item.createdPersonInfo[0].firstName + " " + (item.createdPersonInfo[0].lastName != null ? String(item.createdPersonInfo[0].lastName).replace("-", "") : "")
                }
                let previewData = {
                    'ID': item.id,
                    // 'Employee Name': item.personReferenceId[0].salutation != null ? item.personReferenceId[0].salutation.includes('-') : "" ? withoutSalutation : withSalutation,
                    'Employee Name': item.personReferenceId[0].salutation != null ? withSalutation : withoutSalutation,
                    'Designation': item.designationReferenceId.length !== 0 ? item.designationReferenceId[0].designation : '-',
                    'Department Name': item.departmentReferenceId.length !== 0 ? item.departmentReferenceId[0].description : '-',
                    'Date of Joining': item.joiningDate != "Invalid Date" ? moment(new Date((item.joiningDate))).format('DD/MM/YYYY') : "-",
                    'Annual Salary': item.CTC != "-" ? this.formatCurrency(Number(item.CTC).toFixed(2)) : "-",
                    "Created By": createdBy,
                    "Version": String('V' + Number(item.__v + 1)),
                    'Status': item.status,
                    "Item": JSON.stringify(item)
                }
                this.onPreviewEmployees(previewData)
            }
        } else {

            this.getTime();
            this.getEmployees()
            let employeeDetails = this.state.employeeDetails
        }
        // if (localStorage.getItem("finalCount") != undefined) {
        //     if (localStorage.getItem("finalCount") == 0) {
        //         this.setState({ employeeDetails: [], finalCount: localStorage.getItem("finalCount"), activeTab: 5 }, () => {
        //             this.setState({ employeeDetails: employeeDetails }, () => {
        //                 this.onPreviewEmployees(this.state.employeeDetails['0'])
        //             })
        //         })
        //     }
        //     if (localStorage.getItem("finalCount") == 1) {
        //         let employeeDetails = this.state.employeeDetails
        //         employeeDetails['0']['Status'] = "Exit Pending"
        //         this.setState({ employeeDetails: [], finalCount: localStorage.getItem("finalCount"), activeTab: 5 }, () => {
        //             this.setState({ employeeDetails: employeeDetails }, () => {
        //                 this.onPreviewEmployees(this.state.employeeDetails['0'])
        //             })
        //         })
        //     }
        //     if (localStorage.getItem("finalCount") == 2) {
        //         let employeeDetails = this.state.employeeDetails
        //         employeeDetails['0']['Status'] = "Finance Pending"
        //         this.setState({ employeeDetails: [], finalCount: localStorage.getItem("finalCount"), activeTab: 5 }, () => {
        //             this.setState({ employeeDetails: employeeDetails }, () => {
        //                 this.onPreviewEmployees(this.state.employeeDetails['0'])
        //             })
        //         })
        //     }
        // }
        // this.getEmployees();
        // this.getBranchList();
    }

    componentWillMount() {
        console.log("this.props.workExpData1", this.props.workExpData1)
    }
    formatCurrency = (amount) => {
        return (new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount))
    }
    dateFilter = (ev) => {
        let splitDate = String(ev).split('/')
        let d = String(`${String(splitDate[1])}-${String(splitDate[0])}-${String(splitDate[2])}`)
        var today = new Date(d).toLocaleDateString('en-GB', { day: "numeric", month: "numeric", year: "numeric" })
        return today
    }
    getEmployees = () => {
        this.setState({ loader: true })
        var headers = {
            'Authorization': "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI"
        }
        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/employee?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
            .then(res => {
                console.log(res.data.data)

                if (res.data.status == 'success') {
                    let tabData = [];
                    let data = res.data.data;
                    if (data.length > 0) {
                        data.map(item => {
                            let withSalutation = (item.personReferenceId[0].salutation != null ? (item.personReferenceId[0].salutation + ".") : "") + item.personReferenceId[0].firstName + " " + (item.personReferenceId[0].lastName != null ? String(item.personReferenceId[0].lastName).replace("-", "") : "")
                            let withoutSalutation = item.personReferenceId[0].firstName + " " + (item.personReferenceId[0].lastName != null ? String(item.personReferenceId[0].lastName).replace("-", "") : "")
                            let createdBy = "-"
                            if (item.createdPersonInfo.length > 0) {
                                createdBy = (String(item.createdPersonInfo[0].salutation).length > 1 ? (item.createdPersonInfo[0].salutation + ".") : "") + item.createdPersonInfo[0].firstName + " " + (item.createdPersonInfo[0].lastName != null ? String(item.createdPersonInfo[0].lastName).replace("-", "") : "")
                            }
                            tabData.push({
                                'ID': item.id,
                                // 'Employee Name': item.personReferenceId[0].salutation != null ? item.personReferenceId[0].salutation.includes('-') : "" ? withoutSalutation : withSalutation,
                                'Employee Name': item.personReferenceId[0].salutation != null ? withSalutation : withoutSalutation,
                                'Designation': item.designationReferenceId.length !== 0 ? item.designationReferenceId[0].designation : '-',
                                'Department Name': item.departmentReferenceId.length !== 0 ? item.departmentReferenceId[0].description : '-',
                                'Date of Joining': item.joiningDate != "Invalid Date" ? moment(new Date((item.joiningDate))).format('DD/MM/YYYY') : "-",
                                'Annual Salary': item.CTC != "-" ? this.formatCurrency(Number(item.CTC).toFixed(2)) : "-",
                                "Created By": createdBy,
                                "Version": String('V' + Number(item.__v + 1)),
                                'Status': item.status,
                                "Item": JSON.stringify(item)
                            })
                        })
                        this.setState({
                            loader: false,
                            tabData: tabData,
                            page: res.data.currentPage,
                            limit: res.data.perPage,
                            totalRecord: res.data.totalRecord,
                            totalPages: res.data.totalPages
                        });
                        if (this.props.location.data != undefined) {
                            this.setState({ globalSearch: true }, () => {
                                this.onPreviewEmployees(this.props.location.data)
                            })
                        }

                    } if (data.length == 0) {
                        this.setState({
                            loader: false, tableResponse: 'No data has been uploaded so far.'
                        });
                    }
                }
            }).catch(err => {
                this.setState({
                    loader: false, tableResponse: 'No Data'
                });
            })
    }

    employeeForm = (preview, item) => {
        let config = {
            headers: {
                "Authorization": this.state.authToken,
                'Content-Type': 'application/json'
            }
        }
        this.setState({ loader: true })
        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/employee?org=${this.state.orgId}`, config)
            .then(employeeRes => {
                let approverOptions = []
                console.log('employee response', employeeRes.data.data)
                employeeRes.data.data.map(item => {
                    let withSalutation = (item.personReferenceId[0].salutation != null ? (item.personReferenceId[0].salutation + ".") : "") + item.personReferenceId[0].firstName + " " + (item.personReferenceId[0].lastName != null ? String(item.personReferenceId[0].lastName).replace("-", "") : "")
                    approverOptions.push({
                        label: withSalutation,
                        value: item.id
                    })
                    this.setState({ employeeLists: approverOptions })
                })
                Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/payslip`, config)
                    .then((payslipRes) => {
                        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/department?org=${this.state.orgId}`, config)
                            .then((departmentRes) => {
                                Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/designation?org=${this.state.orgId}`, config)
                                    .then((desinationRes) => {

                                        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/shift?org=${this.state.orgId}`, config)
                                            .then(resDept => {
                                                console.log(resDept.data.data)
                                                if (resDept.data.status == 'success') {
                                                    let shiftOptions = []
                                                    resDept.data.data.map(item => {
                                                        shiftOptions.push({
                                                            label: item.title,
                                                            value: item._id
                                                        })
                                                    })

                                                    if (payslipRes.data.data.length > 0) {
                                                        let pitems = payslipRes.data.data
                                                        let edata = []
                                                        let ddata = []
                                                        let tdata = []
                                                        pitems.sort((a, b) => new Date(a.format).getTime() - new Date(b.format).getTime()).map((item, index) => {
                                                            if (item.type == "Earning") {
                                                                edata.push({
                                                                    "name": item['name']
                                                                })
                                                            }
                                                            else if (item.type == "Deduction") {
                                                                ddata.push({
                                                                    "name": item['name']
                                                                })
                                                            }
                                                            else if (item.type == "extra") {
                                                                tdata.push({
                                                                    "name": item['name']
                                                                })
                                                            }
                                                        })
                                                        employeeForm["Employee Details"].map((item, i) => {
                                                            if (item.name == "BU") {
                                                                let depOptions = []
                                                                if (departmentRes.data.data.length > 0) {
                                                                    departmentRes.data.data.map(dItem => {
                                                                        depOptions.push({
                                                                            "label": dItem.name,
                                                                            "value": dItem.id
                                                                        })
                                                                    })
                                                                }
                                                                employeeForm["Employee Details"][i]["options"] = depOptions
                                                            }
                                                            if (item.name == "designation") {
                                                                let desOptions = []
                                                                if (desinationRes.data.data.length > 0) {
                                                                    desinationRes.data.data.map(dItem => {
                                                                        desOptions.push({
                                                                            "label": dItem.designation,
                                                                            "value": dItem.id
                                                                        })
                                                                    })
                                                                }
                                                                employeeForm["Employee Details"][i]["options"] = desOptions
                                                            }
                                                            if (item.name == "primaryApprover" || item.name == "secondaryApprover") {
                                                                employeeForm["Employee Details"][i]["options"] = approverOptions
                                                            }
                                                        })
                                                        edata.reverse().map((item, i) => {
                                                            let isAdd = false
                                                            employeeForm["Employee Details"].map(fd => {
                                                                if (fd["type"] != "heading") {
                                                                    if (fd['name'] == item.name) {
                                                                        isAdd = true
                                                                    }
                                                                }
                                                            })
                                                            if (i == 0) {
                                                                if (!isAdd) {
                                                                    employeeForm["Employee Details"].push({
                                                                        "type": "heading",
                                                                        "label": "Earnings",
                                                                        "class": "form-hd"
                                                                    })

                                                                    employeeForm["Employee Details"].push({
                                                                        "category": "input",
                                                                        "type": "text",
                                                                        "name": item.name,
                                                                        "label": item.name,
                                                                        "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                        "readOnly": false,
                                                                        "required": false,
                                                                        "requiredBoolean": false,
                                                                        "payslipItem": true
                                                                    })
                                                                }

                                                            } else {
                                                                if (!isAdd) {
                                                                    employeeForm["Employee Details"].push({
                                                                        "category": "input",
                                                                        "type": "text",
                                                                        "name": item.name,
                                                                        "label": item.name,
                                                                        "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                        "readOnly": false,
                                                                        "required": false,
                                                                        "requiredBoolean": false,
                                                                        "payslipItem": true
                                                                    })
                                                                }

                                                            }
                                                        })
                                                        ddata.reverse().map((item, i) => {
                                                            let isAdd = false
                                                            employeeForm["Employee Details"].map(fd => {
                                                                if (fd["type"] != "heading") {
                                                                    if (fd['name'] == item.name) {
                                                                        isAdd = true
                                                                    }
                                                                }
                                                            })
                                                            if (i == 0) {
                                                                if (!isAdd) {
                                                                    employeeForm["Employee Details"].push({
                                                                        "type": "heading",
                                                                        "label": "Deductions",
                                                                        "class": "form-hd"
                                                                    })

                                                                    employeeForm["Employee Details"].push({
                                                                        "category": "input",
                                                                        "type": "text",
                                                                        "name": item.name,
                                                                        "label": item.name,
                                                                        "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                        "readOnly": false,
                                                                        "required": false,
                                                                        "requiredBoolean": false,
                                                                        "payslipItem": true
                                                                    })
                                                                }

                                                            } else {
                                                                if (!isAdd) {
                                                                    employeeForm["Employee Details"].push({
                                                                        "category": "input",
                                                                        "type": "text",
                                                                        "name": item.name,
                                                                        "label": item.name,
                                                                        "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                        "readOnly": false,
                                                                        "required": false,
                                                                        "requiredBoolean": false,
                                                                        "payslipItem": true
                                                                    })
                                                                }
                                                            }
                                                        })
                                                        tdata.reverse().map((item, i) => {
                                                            let isAdd = false
                                                            employeeForm["Employee Details"].map(fd => {
                                                                if (fd["type"] != "heading") {
                                                                    if (fd['name'] == item.name) {
                                                                        isAdd = true
                                                                    }
                                                                }
                                                            })
                                                            if (i == 0) {
                                                                if (!isAdd) {
                                                                    employeeForm["Employee Details"].push({
                                                                        "type": "heading",
                                                                        "label": "Total",
                                                                        "class": "form-hd"
                                                                    })

                                                                    employeeForm["Employee Details"].push({
                                                                        "category": "input",
                                                                        "type": "text",
                                                                        "name": item.name,
                                                                        "label": item.name,
                                                                        "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                        "readOnly": false,
                                                                        "required": false,
                                                                        "requiredBoolean": false,
                                                                        "payslipItem": true
                                                                    })
                                                                }
                                                            } else {
                                                                if (!isAdd) {
                                                                    employeeForm["Employee Details"].push({
                                                                        "category": "input",
                                                                        "type": "text",
                                                                        "name": item.name,
                                                                        "label": item.name,
                                                                        "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                        "readOnly": false,
                                                                        "required": false,
                                                                        "requiredBoolean": false,
                                                                        "payslipItem": true
                                                                    })
                                                                }
                                                            }
                                                        })
                                                        this.setState({ employeeFormData: employeeForm }, () => {
                                                            console.log("globalsearch", this.props)
                                                            if (preview == true) {

                                                                let employeeFormData = this.state.employeeFormData
                                                                let details = JSON.parse(item.Item)
                                                                console.log("-----------details------", details)
                                                                let objKeys = Object.keys(details)
                                                                let entityInstanceId = details['_id']
                                                                let edata = details.salaryDetails != undefined ? JSON.parse(details.salaryDetails) : {};
                                                                console.log("edata", edata)
                                                                let objValue = Object.values(edata)
                                                                console.log("objValue", objValue)

                                                                this.setState({ employeeId: item['ID'], employeeName: item['Name'], idosId: details['idos_id'], entityInstanceId: entityInstanceId })
                                                                this.setState({ tabview: false, preview: true })


                                                                // Object.values(objValue).map((item, i) => {
                                                                //     console.log("item", item)
                                                                //     //debugger
                                                                //     if (i == 0) {
                                                                //         employeeFormData["Employee Details"].push({
                                                                //             "type": "heading",
                                                                //             "label": "Earnings",
                                                                //             "class": "form-hd"
                                                                //         })

                                                                //         employeeFormData["Employee Details"].push({
                                                                //             "category": "input",
                                                                //             "type": "text",
                                                                //             "name": item,
                                                                //             "label": item,
                                                                //             "defaultValue": item,
                                                                //             "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                //             "readOnly": false,
                                                                //             "required": false,
                                                                //             "requiredBoolean": false,
                                                                //             "payslipItem": true
                                                                //         })
                                                                //     } else {
                                                                //         employeeFormData["Employee Details"].push({
                                                                //             "category": "input",
                                                                //             "type": "text",
                                                                //             "name": item,
                                                                //             "label": item,
                                                                //             "defaultValue": item,
                                                                //             "class": "input-wrap branch-input input-margin txt-uppercase",
                                                                //             "readOnly": false,
                                                                //             "required": false,
                                                                //             "requiredBoolean": false,
                                                                //             "payslipItem": true
                                                                //         })
                                                                //     }
                                                                // })

                                                                let workExp = details.workExperienceReferenceId
                                                                if (workExp.length > 0) {
                                                                    this.state.workExpData = []
                                                                    workExp.map((item, idx) => {
                                                                        this.state.workExpData.push({
                                                                            'id': item.id,
                                                                            'companyName': item.companyName,
                                                                            'fromDate': item.from,
                                                                            'toDate': item.to,
                                                                            'attachments': JSON.parse(item.experienceLetter)
                                                                        })
                                                                    })
                                                                    this.setState(this.state.workExpData);
                                                                }
                                                                else {
                                                                    this.setState({
                                                                        workExpData: [{
                                                                            'id': "",
                                                                            'companyName': "",
                                                                            'fromDate': "",
                                                                            'toDate': "",
                                                                            'attachments': []
                                                                        }]
                                                                    })
                                                                }

                                                                objKeys.map(key => {
                                                                    Object.keys(employeeFormData).forEach(dataKey => {
                                                                        employeeFormData[dataKey].map(item => {
                                                                            if (item.name == "id") {
                                                                                item['defaultValue'] = details.id
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "salutation") {
                                                                                item['defaultValue'] = details.personReferenceId[0].salutation !== "-" ? details.personReferenceId[0].salutation : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "firstName") {
                                                                                item['defaultValue'] = details.personReferenceId[0].firstName != "-" ? details.personReferenceId[0].firstName : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "lastName") {
                                                                                item['defaultValue'] = details.personReferenceId[0].lastName != "-" ? details.personReferenceId[0].lastName : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "emPloyeeRole") {
                                                                                // let secondaryOption = []
                                                                                // details.role.map(i => {
                                                                                //     secondaryOption.push(...[i])

                                                                                // })
                                                                                // console.log("secondary", secondaryOption)
                                                                                // item["options"] = secondaryOption
                                                                                item['defaultValue'] = details.role
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            }
                                                                            else if (item.name == "shiftSchedule") {
                                                                                item.options = shiftOptions
                                                                                item['defaultValue'] = details.shiftReferenceId
                                                                                item["error"] = false;
                                                                                item["required"] = item.requiredBoolean
                                                                                item["validation"] = false
                                                                            }

                                                                            else if (item.name == "BU") {
                                                                                item['defaultValue'] = details.departmentReferenceId.length !== 0 ? details.departmentReferenceId[0].id : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "designation") {
                                                                                item['defaultValue'] = details.designationReferenceId.length !== 0 ? details.designationReferenceId[0].id : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "gender") {
                                                                                item['defaultValue'] = details.personReferenceId[0].gender != "-" ? details.personReferenceId[0].gender : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "joiningDate") {
                                                                                // var dateFor = String(details.joiningDate).split('/')
                                                                                //  item['defaultValue'] = new Date(`${dateFor[1]}-${dateFor[0]}-${dateFor[2]}`)
                                                                                item['defaultValue'] = details.joiningDate != "Invalid Date" ? details.joiningDate : ""
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "bloodgroup") {
                                                                                item['defaultValue'] = details.personReferenceId[0]['bloodGroup']
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "PAN") {
                                                                                item['defaultValue'] = details.personReferenceId[0]['PAN']
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "employmentType") {
                                                                                // item['defaultValue'] = details['employmentType'] !== '-' ? String(details['employmentType']).toLowerCase().replace(/ /g, "") : '-'
                                                                                item['defaultValue'] = details['employmentType'] != "null" ? String(details['employmentType']).toLowerCase() : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "primaryApprover") {
                                                                                // item['defaultValue'] = details['primaryApprover'] !== '-' ? String(details['primaryApprover']).toLowerCase().replace(/ /g, "") : '-'
                                                                                item['defaultValue'] = details['primaryApprover'] != "null" ? String(details['primaryApprover']).toLowerCase() : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "secondaryApprover") {
                                                                                // item['defaultValue'] = details['secondaryApprover'] !== '-' ? String(details['secondaryApprover']).toLowerCase().replace(/ /g, "") : '-'
                                                                                item['defaultValue'] = details['secondaryApprover'] != "null" ? String(details['secondaryApprover']).toLowerCase() : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "jobType") {
                                                                                item['defaultValue'] = details.personReferenceId[0]['jobType'] !== '-' ? String(details.personReferenceId[0]['jobType']).toLowerCase() : '-'
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "permanent_address1") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentAddress.address1 != "-" ? details.personReferenceId[0].permanentAddress.address1 : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "permanent_address2") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentAddress.address2 != "-" || details.personReferenceId[0].permanentAddress.address2 != null ? details.personReferenceId[0].permanentAddress.address2 : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "permanent_address3") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentAddress.address3 != "-" ? details.personReferenceId[0].permanentAddress.address3 : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "permanent_city/town") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentAddress.city
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "permanent_state") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentAddress.state
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "permanent_pincode") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentAddress.PINCode != "-" ? details.personReferenceId[0].permanentAddress.PINCode : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "isSameAs") {
                                                                                item['defaultValue'] = details.personReferenceId[0].permanentSameAsCurrent ? "true" : "false"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "local_address1") {
                                                                                item['defaultValue'] = details.personReferenceId[0].currentAddress.address1 != "-" ? details.personReferenceId[0].currentAddress.address1 : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "local_address2") {
                                                                                item['defaultValue'] = details.personReferenceId[0].currentAddress.address2 != "-" ? details.personReferenceId[0].currentAddress.address2 : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "local_address3") {
                                                                                item['defaultValue'] = details.personReferenceId[0].currentAddress.address3 != "-" ? details.personReferenceId[0].currentAddress.address3 : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "local_city/town") {
                                                                                item['defaultValue'] = details.personReferenceId[0].currentAddress.city
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "local_state") {
                                                                                item['defaultValue'] = details.personReferenceId[0].currentAddress.state
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "local_pincode") {
                                                                                item['defaultValue'] = details.personReferenceId[0].currentAddress.PINCode != "-" ? details.personReferenceId[0].currentAddress.PINCode : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "email") {
                                                                                item['defaultValue'] = details.personReferenceId[0].email
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item.name == "phonenumber") {
                                                                                item['defaultValue'] = details.personReferenceId[0].phoneNumber1
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "bankname") {
                                                                                item['defaultValue'] = details.financeReferenceId[0].bankName
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "bankaccountname") {
                                                                                item['defaultValue'] = details.financeReferenceId[0].bankAccountName
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "bankaccountnumber") {
                                                                                item['defaultValue'] = details.financeReferenceId[0].bankAccountNumber
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "bankifsc") {
                                                                                item['defaultValue'] = details.financeReferenceId[0].bankIFSC
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "pfaccountnumber") {
                                                                                item['defaultValue'] = details.statutoryDetails.pfAccountNumber != "-" ? details.statutoryDetails.pfAccountNumber : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "ESIIP") {
                                                                                item['defaultValue'] = details.statutoryDetails.esicInsuranceNumber != "-" ? details.statutoryDetails.esicInsuranceNumber : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "esiaccountnumber") {
                                                                                item['defaultValue'] = details.statutoryDetails.esiAccountNumber != "-" ? details.statutoryDetails.esiAccountNumber : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "UAN") {
                                                                                item['defaultValue'] = details.statutoryDetails.UAN != "-" ? details.statutoryDetails.UAN : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            }
                                                                            else if (item['name'] == "CTC") {
                                                                                item['defaultValue'] = details.CTC != "-" ? this.formatCurrency(Number(details.CTC).toFixed(2)) : "-"
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            } else if (item['name'] == "Adhaar") {
                                                                                item['defaultValue'] = details.personReferenceId[0].Adhaar
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            }
                                                                            else if (item['name'] == "DOB") {
                                                                                //var dateFor = details.personReferenceId[0].DOB !== '-' ? String(details.personReferenceId[0].DOB).split('/') : null
                                                                                // item['defaultValue'] = new Date(`${dateFor[1]}-${dateFor[0]}-${dateFor[2]}`)
                                                                                item['defaultValue'] = details.personReferenceId[0].DOB != "-" ? details.personReferenceId[0].DOB : ""
                                                                                item['readOnly'] = false
                                                                                item['required'] = false
                                                                            }
                                                                            else if (dataKey == "Employee Details" && item.payslipItem != undefined && Object.keys(edata).length > 0) {
                                                                                item['defaultValue'] = edata[item.name]
                                                                            }
                                                                        })
                                                                    })
                                                                })

                                                                this.setState({ loader: false })

                                                            }
                                                            else {

                                                                this.setState({
                                                                    loader: false, tabview: false, preview: false, employeeId: "", workExpData: [{
                                                                        'id': "",
                                                                        'companyName': "",
                                                                        'fromDate': "",
                                                                        'toDate': "",
                                                                        'attachments': []
                                                                    }]
                                                                })


                                                            }

                                                        })

                                                    }
                                                }
                                            })
                                    })
                            })

                    })
            })



    }

    componentWillMount() {


    }
    getTime = () => {
        setInterval(() => {
            this.setState({
                printTime: moment(new Date()).format('DD/MM/YYYY (hh:mm:ss A)').toLocaleString()
            })
        }, 1000)
    }
    showHistory = () => {
        this.setState({ history: true, showHistory: true })
    }
    onCloseForm = () => {
        this.setState({ showHistory: false })
    }

    getBranchList = () => {
        let apiDetails = {
            url: `${this.state.env['zqBaseUri']}/master/get/branches?org=${this.state.orgId}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('auth_token')
            }
        }
        this.zq_api.get(apiDetails)
            .then((response) => {
                console.log("Get Branch List API", response)
                let apiData = response.data;
                let branchList = []
                apiData.forEach(item => {
                    let branchObj = {}
                    branchObj.label = item['branchDetails'].branchName;
                    branchObj.value = item._id;
                    branchList.push(branchObj)
                })
                let formData = this.state.employeeFormData;
                formData['CTC Details'].map(item => {
                    if (item.name === 'selectbranch') {
                        item['options'] = branchList
                    }
                })
                this.setState({ branchList: branchList, apiData: apiData });
            })
    }

    getChangeHistory = (entityInstanceId) => {
        Axios.get(`${this.state.env['zqBaseUri']}/master/changeHistory/getChangeHistory?org=${this.state.orgId}&entity=employee&entityInstanceId=${entityInstanceId}`)
            .then((response) => {
                let api_data = response.data
                let historyData = []
                api_data.sort((data1, data2) => { return Number(data2.created_at) - Number(data1.created_at) })
                api_data.map(item => {
                    let date = new Date(new Intl.DateTimeFormat('en-US', { month: '2-digit', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(item['created_at']))
                    let descriptionData = item.description['0'].split(',').map((desc, i) => {
                        return <p key={i}><div style={{ display: "flex" }}><span className="span-hist" style={{ width: "5%" }}>-</span>{desc}</div></p>;
                    })
                    historyData.push({
                        "description": descriptionData,
                        "time": moment(date).format("hh:mm"),
                        "created_at": item['created_at'] ? moment(date).format('DD/MM/YYYY (hh:mm A)') : "-",
                        "version": item.version,
                        "btn": false
                    })
                })
                this.setState({ historyData: historyData })
            })
            .catch(err => {
                console.log(err)
            })
    }

    onPaginationChange = (page, limit) => {
        this.setState({ page: page, limit: limit }, () => {
            this.getEmployees()
        })
    }
    onPreviewEmployees1 = (item) => {
        this.setState({ employeeId: item['ID'] })
        let employeeFormData = this.state.editForm
        let fullName = item['Employee Name']
        let firstName = String(item['Employee Name']).split()[0]
        let lastName = String(item['Employee Name']).split()[1]
        this.setState({ employeeName: item['Employee Name'], employeeStatus: item['Status'] })
        // employeeFormData['Employee Details']['1']['defaultValue'] = item['ID']
        // employeeFormData['Employee Details']['2']['defaultValue'] = firstName
        // employeeFormData['Employee Details']['3']['defaultValue'] = lastName
        // employeeFormData['Employee Details']['4']['defaultValue'] = item['Department']
        // employeeFormData['Finance Details']['2']['defaultValue'] = fullName
        // employeeFormData['Contact Details']['14']['defaultValue'] = String(fullName).toLowerCase().split(' ')["0"] + '@gmail.com'
        // employeeFormData['Exit Details']['0']['defaultValue'] = new Date()
        // employeeFormData['Exit Details']['2']['defaultValue'] = "satya@gmail.com"
        // employeeFormData['Exit Details']['3']['defaultValue'] = "9876543212"

        // let details = this.state.globalSearch ? item : JSON.parse(item.Item)
        // let objKeys = Object.keys(details)
        // let entityInstanceId = details['_id']
        // this.setState({ employeeName: item['Name'], idosId: details['idos_id'], entityInstanceId: entityInstanceId })
        this.setState({ tabview: false, preview: true, employeeFormData: employeeFormData })
        //         Annual CTC: " ₹ 480,000.00"
        // Created By: "Admin"
        // Created On: "04/12/2020"
        // Date of Joining: "01/12/2018"
        // Department: "Technology"
        // Designation: "Software Engineer"
        // Employee Name: "Satya Ranjan Jena"
        // ID: "EMP001"
        // Status: "Finance Pending"
        // objKeys.map(key => {
        //     Object.keys(employeeFormData).forEach(dataKey => {
        //         employeeFormData[dataKey].map(item => {
        //             let itemName = item.name != undefined ? item.name.toLowerCase().replace(/ /g, "") : ""
        //             let keyName = key.toLowerCase().replace(/ /g, "")
        //             if (keyName == itemName) {
        //                 item['defaultValue'] = details[key]
        //                 item['readOnly'] = false
        //                 item['required'] = false
        //             }
        //             if (itemName == 'typeofemployment') {
        //                 item['defaultValue'] = String(details['typeOfEmployment']).toLowerCase()
        //                 item['readOnly'] = false
        //                 this.setState({ Employee: String(details['typeOfEmployment']).toLowerCase() })
        //             }
        //             if (itemName == 'employeeid') {
        //                 item['defaultValue'] = details['employeeId']
        //                 item['readOnly'] = true
        //             }
        //             if (itemName == 'selectbranch') {
        //                 item['defaultValue'] = details['branchId']
        //                 item['readOnly'] = false
        //                 item['required'] = false
        //             }
        //             if (itemName == 'selectbranch') {
        //                 item['defaultValue'] = details['branchId']
        //                 item['readOnly'] = false
        //             }
        //             if (employeeFormData["CTC Details"][1].defaultValue == 'employee') {
        //                 employeeFormData["CTC Details"]['3']['label'] = "PF Account No"
        //                 employeeFormData["CTC Details"]['3']['requiredBoolean'] = false
        //                 employeeFormData["CTC Details"]['4']['label'] = "UAN"
        //                 employeeFormData["CTC Details"]['4']['requiredBoolean'] = false
        //             } else {
        //                 employeeFormData["CTC Details"]['3']['label'] = "PF Account No"
        //                 employeeFormData["CTC Details"]['3']['requiredBoolean'] = false
        //                 employeeFormData["CTC Details"]['4']['label'] = "UAN"
        //                 employeeFormData["CTC Details"]['4']['requiredBoolean'] = false
        //             }
        //         })
        //     })

        // })
        // this.getChangeHistory(entityInstanceId)
    }
    onPreviewEmployees = (item) => {

        this.employeeForm(true, item);


    }

    handleBack = () => {
        if (this.props.location.status != "active") {
            this.resetform()
            this.setState({ tabview: true })
        }
        else {
            this.props.history.goBack();
        }
    }

    onAddEmployees = () => {
        this.employeeForm(false, undefined);

    }
    resetform = () => {
        let employeeFormData = this.state.employeeFormData
        Object.keys(employeeFormData).forEach(tab => {
            employeeFormData[tab].forEach(task => {
                delete task['defaultValue']
                task['readOnly'] = false
                task['error'] = false
                task['required'] = task['requiredBoolean']
                task['validation'] = false
            })
        })
        this.setState({ employeeFormData })
    }
    formBtnHandle = (item) => {
        return item === "clear" ? this.cleartabData() : this.canceltabData();
    };
    cleartabData = () => {
        this.resetform()
    }
    canceltabData = () => {
        this.resetform()
        this.setState({ tabview: true })

    }
    handleTabChange = (tabName, formDatas) => {

        console.log(tabName)
        console.log(formDatas)
    }
    onFormSubmit = (data, item) => {
        console.log("tab", this.tabRef)
        //return
        let workExperience = this.tabRef.current.state.workExpData1
        this.setState({ loader: true }, () => {
            let payload = {}
            payload['salaryDetails'] = {}
            payload['workExperienceDetails'] = workExperience
            Object.keys(data).map(key => {
                data[key].map(item => {
                    payload[item.name] = item.defaultValue == undefined ? null : item.defaultValue
                    if (item.payslipItem != undefined) {
                        payload['salaryDetails'][item.name] = item.defaultValue == undefined ? null : item.defaultValue
                    }
                })
            })
            let config = {
                headers: {
                    "Authorization": this.state.authToken,
                    'Content-Type': 'application/json'
                }
            }
            console.log('payload', payload)
            this.state.employeeLists.map(item => {
                if (payload['primaryApprover'] == item.value) {
                    payload['primaryApproverDetails'] = {
                        name: item.label,
                        id: item.value
                    }
                }
                if (payload['secondaryApprover'] == item.value) {
                    payload['secondaryApproverDetails'] = {
                        name: item.label,
                        id: item.value
                    }
                }
            })
            if (payload.workExperienceDetails.length > 0) {
                for (let ai = 0; ai < payload.workExperienceDetails.length; ai++) {
                    console.log('ai', ai)
                    let eltWE = payload.workExperienceDetails[ai];
                    payload.workExperienceDetails[ai]['attachFiles'] = []
                    let attachFiles = []
                    console.log('eltWE', eltWE)
                    console.log('eltWE length', eltWE["attachments"].length)
                    if (eltWE["attachments"].length > 0) {
                        for (let afi = 0; afi < eltWE["attachments"].length; afi++) {
                            if (eltWE["attachments"][afi].file != undefined) {
                                let fd = new FormData();
                                fd.append('file', eltWE["attachments"][afi].file)
                                Axios.post(`${this.state.env['zqBaseUri']}/payroll/attachment/${payload.id}`, fd, {
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                        'Authorization': this.state.authToken
                                    }
                                }).
                                    then(res => {
                                        console.log(res)
                                        payload.workExperienceDetails[ai]['attachFiles'].push({ name: res.data })
                                        if (payload.workExperienceDetails.length == (ai + 1) && eltWE["attachments"].length == (afi + 1)) {


                                            console.log("payload", payload)
                                            Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/employee`, payload, config)
                                                .then((res) => {
                                                    console.log(res)
                                                    this.setState({ snackBar: true, processMessage: `The employee has been ${this.state.entityInstanceId != undefined ? "updated" : "added"} successfully.` }, () => {
                                                        setTimeout(() => {
                                                            this.setState({ snackBar: false, preview: false, tabview: true }, () => {
                                                                this.getEmployees();
                                                            })
                                                        }, 2000)
                                                    })


                                                }).catch(err => {
                                                    console.log("err", err)
                                                })
                                        }

                                    }).catch(err => {
                                        console.log(err)
                                        this.setState({ noProg: 'No Data', configInfo: false, loader: true })
                                    }
                                    )
                            }


                        }
                    }
                    if (payload.workExperienceDetails.length == (ai + 1)) {

                        Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/employee`, payload, config)
                            .then((res) => {
                                console.log(res)
                                this.setState({ snackBar: true, processMessage: `The employee has been ${this.state.entityInstanceId != undefined ? "updated" : "added"} successfully.` }, () => {
                                    setTimeout(() => {
                                        this.setState({ snackBar: false, preview: false, tabview: true }, () => {
                                            this.getEmployees();
                                        })
                                    }, 2000)
                                })


                            }).catch(err => {
                                console.log("err", err)
                            })
                    }
                }
            }

        })

    }
    onInputChanges = (value, item, e, dataS) => {
        var employeeFormData = this.state.employeeFormData
        if (dataS != undefined) {
            if (dataS["name"] === "DOB") {
                dataS["defaultValue"] = value;
            }
            if (dataS["name"] === "joiningDate") {
                dataS["defaultValue"] = value;
            }
            if (dataS.name == "typeofemployment") {
                console.log(this.state.employeeFormData)
                this.setState({ Employee: value })
                if (value == "consultant") {
                    employeeFormData["CTC Details"]['3']['label'] = "PF Account No"
                    employeeFormData["CTC Details"]['3']['requiredBoolean'] = false
                    employeeFormData["CTC Details"]['4']['label'] = "UAN"
                    employeeFormData["CTC Details"]['4']['requiredBoolean'] = false
                } else {
                    employeeFormData["CTC Details"]['3']['label'] = "PF Account No"
                    employeeFormData["CTC Details"]['3']['requiredBoolean'] = false
                    employeeFormData["CTC Details"]['4']['label'] = "UAN"
                    employeeFormData["CTC Details"]['4']['requiredBoolean'] = false
                }
                this.setState({ Employee: value }, () => {
                    this.setState({ employeeFormData: {} }, () => {
                        console.log(employeeFormData)
                        this.setState({ employeeFormData: employeeFormData })
                    })
                })
            }
        }
        else {
            item["defaultValue"] = value
        }
    }
    handleActionClick = (item, index, hd, name) => {
        console.log('item', item)
        console.log('index', index)
        console.log('hd', hd)
        console.log('name', name)
        if (name == "Resign") {
            this.onPlanningApproval()
        }
    }
    onPlanningApproval = () => {
        let a = this.state.modelboxDetails;
        a.openNotificationModel = true;
        a.modelHeading = "Submit";
        // a.modelBodyContent = `<input type="text" /> <p>Do you want send the payroll processing request to the bank?</p>`;
        a.modelFooterSubBtn = true;
        a.modelFooterCancelBtn = true;
        a.modelStatus = "";
        this.setState({ modelboxDetails: a });
    }
    cancelAddMapModel = () => {
        let a = this.state.modelboxDetails;
        a.openNotificationModel = false;
        a.modelHeading = "";
        a.modelBodyContent = "";
        a.modelFooterSubBtn = false;
        a.modelFooterCancelBtn = false;
        a.modelStatus = "";
        this.setState({ modelboxDetails: a });
    };
    confirmSendDemandNote = () => {
        let a = this.state.modelboxDetails;
        a.openNotificationModel = false;
        a.modelHeading = "";
        a.modelBodyContent = "";
        a.modelFooterSubBtn = false;
        a.modelFooterCancelBtn = false;
        a.modelStatus = "";
        this.setState({ modelboxDetails: a }, () => {
            this.setState({ snackBar: true, processMessage: "The payroll processing has been sent successfully." }, () => {
                setTimeout(() => {
                    this.setState({ snackBar: false }, () => {
                        let processingData = this.state.processingData
                        processingData.map(item => {
                            item['Status'] = "Processed"
                        })
                        let InvoiceLists = this.state.InvoiceLists
                        InvoiceLists['0'] = "Processed"
                        this.setState({ processingData: [], InvoiceLists: [] }, () => {
                            localStorage.setItem("notifCount", 1)
                            this.setState({ processingData: processingData, InvoiceLists: InvoiceLists })
                        })
                    })
                }, 1000)
            })
        });
    }
    onExitSubmit = (data, item) => {
        let employeeDetails = this.state.employeeDetails
        localStorage.setItem("finalCount", 1)
        employeeDetails['0']['Status'] = "Exit Initiated"
        this.setState({ employeeDetails: [], tabview: true, finalCount: localStorage.getItem("finalCount") }, () => {
            this.setState({ employeeDetails: employeeDetails })
            this.cancelAddMapModel()
            this.setState({ snackBar: true, processMessage: "The exits form has been sent successfully." }, () => {
                setTimeout(() => {
                    this.setState({ snackBar: false, preview: false, tabview: true }, () => { })
                }, 2000)
            })
        })
    }
    onUpload = () => {
        this.setState({ showTable: false, showPayslipTable: true, showUploadform: false })
    }
    uploadCancel = () => {
        this.setState({ showUploadform: true, upload: false })
    }
    submitProcessingTemplate = () => {
        var formData = new FormData();
        var payload = this.state.uploadTemplatePayload;
        console.log('filename', this.state.filename)
        // formData.append('file', this.state.uploadTemplatePayload);
        formData.append("file", this.state.uploadTemplatePayload, this.state.filename)
        formData.append("orgId", this.state.orgId);
        console.log(formData)
        this.setState({ loader: true }, () => {

            let config = {
                headers: {
                    "Authorization": this.state.authToken,
                    'Content-Type': 'multipart/form-data'
                }
            }
            Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/add/bulkemployee`, formData, config)
                .then(response => {
                    // res.json().then(response => {
                    console.log("processing upload template api response", response);
                    setTimeout(() => {
                        this.getEmployees();
                    }, 1000);
                    this.setState({ showUploadform: true, upload: false })
                    this.setState({ noProg: "Fetching Details..", MonthLists: [] })
                })
                .catch(err => {
                    console.log("error occured in processing upload submit API");
                    this.setState({ noProg: "No Data", showUploadform: true, upload: false })
                    this.setState({ loader: false })
                })

        })
    }

    //   upload process for Payroll ProcessingInstruction.............................................
    fileSelected = (ev, i) => {
        console.log(ev.target.files)

        // let workBook = null;
        // let jsonData = null;
        // const reader = new FileReader();
        const file = ev.target.files[0];
        this.setState({ upload: true, filename: file.name, uploadTemplatePayload: file }, () => {
            this.onLoad(0)
        })
    }

    onLoad = load => {
        if (this.state.pdfLoaded == 100) {
            if (this.state.processLoaded < 100) {
                let loadValue = this.state.processLoaded + 5
                this.setState({ processLoaded: loadValue }, () => {
                    setTimeout(() => {
                        this.onLoad(loadValue)
                    }, 100)
                })
            } else {
                this.setState({ extractData: true }, () => {

                })
            }
        } else {
            let loadValue = this.state.pdfLoaded + 5
            this.setState({ pdfLoaded: loadValue }, () => {
                setTimeout(() => {
                    this.onLoad(loadValue)
                }, 100)
            })
        }
    }
    downloadBulkEmployeeTemplate = () => {
        let createXlxsData = [{
            "ID *": "",
            "Salutation": "",
            "First Name *": "",
            "Last Name *": "",
            "Gender *": "",
            "Email": "",
            "Date of Birth *": "",
            "Blood Group": "",
            "Department ID*": "",
            "Designation ID*": "",
            "Role IDs *": "",
            "Joining Date *": "",
            "employment Type *": "",
            "Job Type": "",
            "Is Fresher	CTC (Annual) *": "",
            "Personal email": "",
            "Phone Number 1 *": "",
            "Phone Number 2": "",
            "PAN *": "",
            "Adhaar *": "",
            "Current Address 1 *": "",
            "Current Address 2 *": "",
            "Current Address 3 *": "",
            "City *": "",
            "State *": "",
            "Country *": "",
            "Pincode *": "",
            "Permanent Same As Current": "",
            "ermanent  Address 1	": "",
            "ermanent Address 2	": "",
            "Permanent Address 3": "",
            "Landmark": "",
            "City": "",
            "State": "",
            "Country": "",
            "Pincode": "",
            "Bank Name": "",
            "Bank IFSC": "",
            "Bank Account Number": "",
            "Bank Account Name": "",
            "UAN": "",
            "PF Account Number": "",
            "ESI IP": "",
            "ESI Account Number": "",
            "Passport Number": "",
            "Driving License Number": "",
            "Emergency Contact Name": "",
            "Emergency Contact Number": "",
            "Emergency Contact email": "",
            "Status": "",
            "casualLeave": "",
            "earnedLeave": "",
            "vacationLeave": "",
            "medicalLeave": "",
            "compensatoryLeave": "",
            "marraigeLeave": "",
            "maternityLeave": "",
            "splCasualLeave": "",
            "LossOfPayDays": "",
            "institute": "",
            "Primary Approver": "",
            "Secondary Approver": ""
        }]
        var wscols = []
        var findCellWidth = {}
        var cellKeys = Object.keys(createXlxsData['0'])
        createXlxsData.map((key, keyIndex) => {
            cellKeys.map(cellKey => {
                if (findCellWidth[cellKey] != undefined) {
                    findCellWidth[cellKey] = Number(findCellWidth[cellKey]) > String(key[cellKey]).length ? findCellWidth[cellKey] : String(key[cellKey]).length
                } else {
                    console.log(cellKeys[cellKey], String(cellKeys[cellKey]).length)
                    findCellWidth[cellKey] = Number(String(cellKey).length)
                }
            })
        })
        console.log(findCellWidth)
        cellKeys.map(cellKey => {
            wscols.push({ wch: findCellWidth[cellKey] + 5, s: { font: { bold: true } } })
        })
        console.log(xlsx)
        var ws = xlsx.utils.json_to_sheet(createXlxsData);
        ws['!cols'] = wscols;
        var wb = xlsx.utils.book_new();
        var sheetMonth = `Add Employee Sheet`
        console.log('sheetMonth', sheetMonth)
        xlsx.utils.book_append_sheet(wb, ws, sheetMonth);
        xlsx.writeFile(wb, `${sheetMonth}.xlsx`);
    }
    render() {
        const onButtonClick = () => {
            this.inputFile.current.click()
        }
        return (<React.Fragment>
            {/* {this.state.loader ? <Loader /> : null} */}
            <div className="setup-wrap">
                {this.state.tabview ?
                    <React.Fragment>
                        <div className="trial-balance-header-title">
                            <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                                marginRight: '5px',
                                cursor: 'pointer',
                                marginTop: '0px'
                            }} />
                            <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Employees</p>
                        </div>
                        {
                            this.state.showUploadform ?
                                <div className="invoice-page-wrapper new-table-wrap">
                                    {this.state.containerNav && !this.state.showTable == undefined ? null : <React.Fragment><KenContainerNavbar containerNav={this.state.containerNav} onUpload={() => { this.onUpload() }} onAddNew={this.onAddEmployees} onDownload={this.downloadBulkEmployeeTemplate} /><div className="print-time">{this.state.printTime}</div></React.Fragment>}
                                    <div className="table-wrapper" style={{ marginTop: "10px" }}>
                                        {this.state.tabData.length == 0 || this.state.loader ? <p className="noprog-txt">{this.state.tableResponse}</p> : <React.Fragment>
                                            <div className="remove-last-child-table" >
                                                <KenTable data={this.state.tabData} onRowCheckBox={(item) => { this.onPreviewEmployees(item) }}
                                                    rowClick={(item) => { this.onPreviewEmployees(item) }} handleActionClick={this.handleActionClick} />
                                            </div> </React.Fragment>}
                                        {this.state.tabData.length !== 0 && <KenPaginationUI
                                            onPaginationApi={this.onPaginationChange}
                                            totalPages={this.state.totalPages}
                                            limit={this.state.limit}
                                            total={this.state.totalRecord} />}
                                    </div>

                                </div> :
                                this.state.showTable ? null :
                                    <React.Fragment>
                                        <div className='invoice-page-wrapper'>
                                            <div className='create-invoice-page-header' style={{ display: 'flex', marginBottom: '20px' }}>
                                                <div className='header-title' style={{ width: '50%' }}>
                                                    <div className='goods-btns'>
                                                        <div className='goods-header-wrap'>
                                                            <h6 className='goods-Id-content'>Upload Processing Excel</h6>
                                                        </div>
                                                        {/* <div className='goods-header-content'>
                                            <p className='goods-content-color'>Home</p>
                                            <ChevronRightIcon
                                                style={{ width: '10px', height: '15px' }}
                                            />
                                            <p>Payroll</p>
                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className="footer-btn-grps" style={{ top: "56px", width: "50%", }}>
                                                    <button variant="contained" style={{ float: "right", border: "solid 1px #dfe1e6", "background": "#fff", "color": "#1359c1" }} type="cancel" className="add-item-btn cancel-btn" onClick={this.uploadCancel}>Cancel</button>
                                                    <button variant="contained" style={{ float: "right" }} type="submit" className="add-item-btn approval-btn" onClick={this.submitProcessingTemplate}>Submit</button>

                                                </div>
                                            </div>
                                            <div className='invoice-custom-table-wrapper invoice-extract-wrap'>

                                                <div className='pdf-extract-wrap' style={{ height: '70%' }}>
                                                    <div className='onboard-card dot-card' onClick={onButtonClick} style={{ height: "calc(100vh - 190px)", width: "100%", alignItems: "center", display: "flex", justifyContent: "center", textAlign: "center" }} >
                                                        {this.state.upload ? (
                                                            <React.Fragment>
                                                                <div className='file-upload-wrap' onClick={event => { event.stopPropagation() }} >
                                                                    {this.state.pdfLoaded !== 100 ? (
                                                                        <span className='file-loaded-percentage'>{this.state.pdfLoaded}%</span>) :
                                                                        (<span className='file-loaded-percentage' style={{ fontSize: '14px', color: '#00b8d9' }}>
                                                                            <i class='fa fa-check' aria-hidden='true'></i>
                                                                        </span>
                                                                        )}
                                                                    <p className='file-process-hd'> Uploading File({this.state.filename}) </p>
                                                                    <LinearProgress color='primary' variant={'determinate'} value={this.state.pdfLoaded} />

                                                                    {this.state.processLoaded !== 100 ? (
                                                                        <span className='file-loaded-percentage process-percentage'>
                                                                            {this.state.processLoaded}%
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className='file-loaded-percentage process-percentage'
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                color: '#00b8d9'
                                                                            }}
                                                                        >
                                                                            <i class='fa fa-check' aria-hidden='true'></i>
                                                                        </span>
                                                                    )}
                                                                    <p className='file-process-hd'>Processing File</p>
                                                                    <LinearProgress
                                                                        color='primary'
                                                                        variant={'determinate'}
                                                                        value={this.state.processLoaded}
                                                                    />
                                                                </div>
                                                            </React.Fragment>
                                                        ) : (
                                                            <div>
                                                                <input
                                                                    type='file'
                                                                    id='file'
                                                                    ref={this.inputFile}
                                                                    style={{ display: 'none' }}
                                                                    onChange={this.fileSelected}
                                                                />
                                                                <div className='card-third-round  '>
                                                                    <PublishOutlinedIcon className='onboard-icons' />
                                                                </div>
                                                                <h6 className='onboard-card-header'>Upload Excel</h6>
                                                                <p className='onboard-card-title' style={{ color: '#000' }} >Drag and drop file or <span className='browse-content'>browse</span>
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                        }

                    </React.Fragment> :
                    <div className="tab-form-wrapper tab-table">
                        <div className="preview-btns">
                            {/* <div className="preview-header-wrap">
                                < KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={this.handleBack} />
                                <h6 className="preview-Id-content">{this.state.preview ? '| Employees | ' + this.state.employeeId : `| Employees | ${this.state.employeeId}`} </h6>
                              </div> */}
                            <div className="trial-balance-header-title">
                                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={this.handleBack} style={{
                                    marginRight: '5px',
                                    cursor: 'pointer',
                                    marginTop: '0px'
                                }} />
                                {/* <p className="top-header-title" onClick={this.handleBack}>
                                    {this.state.preview ? '| Employees | ' + this.state.employeeId : `| Employees | ${this.state.employeeId}`}</p> */}
                                {this.state.preview ?
                                    <p className="top-header-title" onClick={() => { this.handleBack() }}>| Departments | {this.state.employeeId}</p> :
                                    <p className="top-header-title" onClick={() => { this.handleBack() }}>| Departments | {this.state.addEmpId}</p>}
                            </div>


                            {/* <div className="notes-history-wrapper">
                                {this.state.preview ? <div className="history-icon-box" title="View History" onClick={this.showHistory}> <RestoreOutlinedIcon className="material-historyIcon" /> <p>History</p></div> : null}
                            </div> */}
                        </div>
                        {this.state.updateTab ?
                            <ZenTabs key={0} tabData={this.state.employeeFormData} workExpData={this.state.workExpData} className="preview-wrap" form={this.state.employeeFormData} onFormBtnEvent={(item) => { this.formBtnHandle(item); }} onInputChanges={this.onInputChanges} onTabFormSubmit={this.onFormSubmit} handleTabChange={this.handleTabChange} clear={true} activeTab={this.state.activeTab} ref={this.tabRef} />
                            :
                            <ZenTabs key={1} tabData={this.state.employeeFormData} workExpData={this.state.workExpData} className="preview-wrap" form={this.state.employeeFormData} onFormBtnEvent={(item) => { this.formBtnHandle(item); }} onInputChanges={this.onInputChanges} onTabFormSubmit={this.onFormSubmit} handleTabChange={this.handleTabChange} clear={true} activeTab={this.state.activeTab} ref={this.tabRef} />
                        }
                    </div>}
            </div>
            {/* {this.state.history ?
                <Drawer
                    show={this.state.showHistory}
                    onHide={this.close}
                >
                    <ZqHistory historyData={this.state.historyData} onCloseForm={this.onCloseForm} />
                </Drawer>
                : null
            } */}
            <Modal
                className="coa-model-box employee-resign"
                style={{ borderRadius: "2px" }}
                onHide={this.cancelAddMapModel}
                size="xs"
                show={this.state.modelboxDetails.openNotificationModel}
            >
                <Modal.Header>
                    <Modal.Title>Exit Form</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    className="bodyContent"
                    style={{ paddingBottom: "10px", marginTop: "10px" }}
                >
                    <div>
                        <KenForm inputData={this.state.existForm} onSubmit={this.onExitSubmit} />
                        {this.state.modelboxDetails.modelStatus == "error" ? (
                            <span>{<Icon icon="exclamation-triangle" />}</span>
                        ) : this.state.modelboxDetails.modelStatus == "success" ? (
                            <span>
                                <CheckCircleIcon className="check-circle" />
                            </span>
                        ) : this.state.modelboxDetails.modelStatus == "loading" ? (
                            <span>
                                <CircularProgress className="circular-loader-coa" />
                            </span>
                        ) : null}
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    {this.state.modelboxDetails.modelFooterSubBtn == true ? (
                        <React.Fragment>
                            <Button
                                className="process-cancel-button"
                                onClick={this.cancelAddMapModel}
                            >
                                Cancel
                </Button>
                            <Button
                                className="process-confirm-button"
                                onClick={this.confirmSendDemandNote}
                            >
                                Confirm
                </Button>
                        </React.Fragment>
                    ) : null}
                </Modal.Footer> */}
            </Modal>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={this.state.snackBar}
                autoHideDuration={1000}
                message={this.state.processMessage}
                className="success-snackbar"

            />
        </React.Fragment >)
    }
}
export default withRouter(Employees);